import React from 'react';

import InstructionModalTemplate from '../../../../components/DataDisplay/InstructionModalTemplate';
import WarningIcon from '../../../../components/Icons/WarningIcon';
import appConfig from '../../../../config/appConfig';
import * as reconnectGuideTypes from '../../../../consts/app/reconnectGuideTypes';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import {showReconnectDeviceGuideModalAction} from '../../../../state/ducks/modal';
import {dispatch} from '../../../../state/store';

const NotCriticalReconnectGuide = (props) => {
    const {guideData, hideModalGuide} = props;
    const {header, reconnectStepList} = guideData;
    const localizedStrings = getLocalizedStrings();
    const isReconnectDeviceGuideEnabled = appConfig.getIsReconnectDeviceGuideEnabled();

    const onTryAgainClick = () => {
        hideModalGuide();
        if (isReconnectDeviceGuideEnabled) {
            showReconnectDeviceGuide();
        }
    };

    const showReconnectDeviceGuide = () => {
        dispatch(showReconnectDeviceGuideModalAction({guideType: reconnectGuideTypes.REGULAR}));
    };

    return (
        <InstructionModalTemplate
            className='mx-auto w-full py-10'
            subTitleKey={localizationKeys.IO_NOT_CRITICAL_ERROR_SUB_TITLE_TEXT}
            instructionList={reconnectStepList}
            articleProps={{
                titleKey: header,
                className: 'lg:max-w-[724px]',
                icon: <WarningIcon className='mb-4 h-6 w-6 lg:mb-6 lg:h-8 lg:w-8' />,
            }}
            instructionButtonProps={{
                primary: true,
                light: true,
                className: 'w-full mt-10 sm:min-w-[312px] md:w-auto',
                onClick: onTryAgainClick,
                children: localizedStrings[localizationKeys.IO_NOT_CRITICAL_ERROR_TRY_RECONNECTING_BTN],
            }}
        />
    );
};

export default NotCriticalReconnectGuide;
